import { Box, BoxProps } from '@mui/material';
import React from 'react';
import { GetCartQuery, CartItem as CartItemType } from '../../../../generated/graphql';
import { CartItem } from './components/CartItem';

type CartItemListProps = BoxProps & {
    items: GetCartQuery['cart']['cart']['items'];
};

export default function CartItemList(props: CartItemListProps) {
    const { items, sx, ...rest } = props;

    return (
        <Box display="flex" flexDirection="column" flexGrow={2} gap={2} sx={sx}>
            {items.map((item, index) => (
                <CartItem key={index} item={item} {...rest} />
            ))}
        </Box>
    );
}
